module.exports = __webpack_public_path__ + "img/Weapon_21.e5e82401.png";